/** @license ISC License (c) copyright 2019 original and current authors */
/** @author Benny Powers (bennypowers) */

function isMap(x) {
  return x instanceof Map
}

module.exports = isMap
